module.exports = __webpack_public_path__ + "media/images/logo-masthead-05990c085d7742fc6968a1a54ee1838a.svg";